import { render, staticRenderFns } from "./EmailTemplateEditor.vue?vue&type=template&id=ba1b89c2&"
import script from "./EmailTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports